import { useSelector } from "react-redux";
import Maybe from "../common/Maybe";
import useLoginInfo from "hooks/useLoginInfo";


const ComplianceHeader = () => {
    const {userInfo} = useLoginInfo();
    const { complianceProgress } = useSelector((s) => s.entities.compliance);
    
    return (
        <div className="p-6 bg-white md:flex md:space-x-6 items-center justify-between border-t border-b border-gray-100">
            <div>
                <div className="font-bold text-xl">
                    Earnipay Compliance
                </div>
                <div className="text-fade text-sm">
                    Complete each step to access all Earnipay features
                </div>
            </div>
            <div className="md:text-right mt-4 md:mt-0">
                <div className="text-sm">
                    <Maybe condition={complianceProgress < 100}>
                        {complianceProgress}% Done
                    </Maybe>
                    <Maybe condition={complianceProgress === 100}>
                        <Maybe condition={userInfo?.employer?.isCompliant === true}>
                            Verified 🎉
                        </Maybe>
                        <Maybe condition={userInfo?.employer?.isCompliant === false}>
                            <Maybe condition={userInfo?.employer?.status === "review"}>
                                Completed (Verifying)
                            </Maybe>
                            <Maybe condition={userInfo?.employer?.status === "rejected"}>
                                Completed (Could not verify)
                            </Maybe>
                        </Maybe>
                    </Maybe>
                </div>
                <div className="w-48 h-2 mt-1 bg-[#D9D9D9] rounded-md overflow-hidden">
                    <div
                        style={{width: complianceProgress+"%"}}
                        className={`h-full ${userInfo?.employer?.isCompliant ? "bg-ep-primary":"bg-ep-secondary-400"}`}
                    ></div>
                </div>
            </div>
        </div>
    )
}

export default ComplianceHeader;